export default "__VITE_ASSET__BIky6tVF__"